import { lazy } from "react";

export const ContactsAsync = lazy(() => import("./Contacts"));
